// @flow
import React from 'react'
import type { Node } from 'react'
import cx from 'classnames'

type Props = {
  children: Node,
  className: string,
}

const OuterContainer = ({ children, className }: Props) => (
  <div className={cx('px3 sm-px4 md-px5', className)}>{children}</div>
)

export default OuterContainer



// WEBPACK FOOTER //
// ./src/components/helpers/outer-container/outer-container.js